module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Role created","message":"The role can now be assigned to users"},"da":{"title":"Rollen er oprettet","message":"Denne rolle kan nu tildeles til brugere"}}')
  delete Component.options._Ctor
}
